module.exports = __webpack_public_path__ + "img/cover.e8b62ab0.jpg";